/**
 * poppet.Service
 * A generic Marionette-powered Service.
 * @version 0.8.0
 */
const Service = Mn.Object.extend({

	// ------------------------------------------------
	// Setup
	// ------------------------------------------------

	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------

	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------

});

export default Service;